import { useCallback } from 'react';
import { useInfiniteResource } from 'hooks/useInfiniteResource';
import salesforceEntitiesService from 'services/salesforceEntitiesService';

const PER_PAGE = 25;

const useFundraisings = (entityId, filters = {}, sort = {}) => {
	const fetchFn = useCallback(
		async (page) => {
			if (!entityId) return { data: [], totalCount: 0 };
			return await salesforceEntitiesService.getFundraisings(entityId, page, PER_PAGE, filters, sort);
		},
		[entityId, filters, sort]
	);

	const { data, totalCount, loading, loadingMore, error, hasMore, loadMore, refresh } =
		useInfiniteResource({ fetchFn });

	return {
		fundraisings: data,
		totalCount,
		loading,
		loadingMore,
		error,
		hasMore,
		loadMore,
		refresh,
	};
};

export default useFundraisings;
